import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=bab38820&scoped=true"
import script from "./budget.vue?vue&type=script&lang=js"
export * from "./budget.vue?vue&type=script&lang=js"
import style0 from "./budget.vue?vue&type=style&index=0&id=bab38820&prod&scoped=scoped&lang=scss"
import style1 from "./budget.vue?vue&type=style&index=1&id=bab38820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab38820",
  null
  
)

export default component.exports